import React from 'react';

import { useState, useEffect, useRef } from 'react';

import { Formik } from 'formik';
import * as yup from 'yup';

import { Button, Form, Stack, Row, Col } from 'react-bootstrap';

import useRequest from '../helper/useRequest';
import { toast } from 'react-toastify';
import Loader from '../helper/Loader';
import Separator from '../helper/Separator';

import Select from 'react-select';

import { street, houseNo, postCode, city } from '../helper/Schema';

import MandatoryFieldNotice from '../helper/MandatoryFieldNotice';

const schemaSchool = yup.object().shape({
    street: street,
    houseNo: houseNo,
    postCode: postCode,
    city: city,
});

const schemaBusiness = yup.object().shape({
    street: street,
    houseNo: houseNo,
    postCode: postCode,
    city: city,
});

const Organisation = () => {
    const [user, setUser] = useState(false);

    const { request } = useRequest();

    useEffect(() => {
        const getUser = async () => {
            try {
                let result = await request("/User");
                let json = result.data;
                if (json.r != 1) {
                    if (json.message) {
                        toast.error(json.message);
                    }
                    else {
                        toast.error("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.");
                    }
                }
                else {
                    setUser(json.user);
                }
            }
            catch {
                toast.error("Fehler beim Laden.");
            }
        };
        getUser();
    }, []);

    if (!user) {
        return <Loader />
    }

    if (user.Role == "School") {
        return <OrganisationSchool user={user} />
    }
    else if (user.Role == "Business") {
        return <OrganisationBusiness user={user} />
    }
    else {
        return "Weder Schule noch Unternehmen";
    }
}

const OrganisationSchool = (props) => {
    const [equipment, setEquipment] = useState([]);
    const [categories, setCategories] = useState([]);
    const [contactPerson, setContactPerson] = useState([]);
    const [organisation, setOrganiastion] = useState({});

    const formRef = useRef(null);

    const { request } = useRequest();

    const updateSchool = async (values) => {
        let result = await request("/User/UpdateOrganisation", values);
        let json = result.data;
        if (json.r != 1) {
            if (json.message) {
                toast.error(json.message);
            }
            else {
                toast.error("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.");
            }
            return;
        }
        toast.success("Ihre Daten wurden erfolgreich geändert.");
    }

    useEffect(() => {
        const getOrganisationSettings = async () => {
            try {
                let result = await request("/User/GetOrganisationSettings");
                let json = result.data;
                if (json.r != 1) {
                    if (json.message) {
                        aler.error(json.message);
                    }
                    else {
                        toast.error("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut");
                    }
                }
                else {
                    setEquipment(json.equipment.map((val) => { return { value: val.EquipmentID, label: val.Description } }));
                    formRef.current.setFieldValue("equipment", json.oldEquipment.map((val) => { return { value: val.EquipmentID, label: val.Description } }));
                    setCategories(json.categories.map((val) => { return { value: val.CategoryID, label: val.Description } }));
                    formRef.current.setFieldValue("categories", json.oldCategories.map((val) => { return { value: val.CategoryID, label: val.Description }}));
                    setContactPerson(json.contactPerson.map((val) => { return { value: val.ContactPersonID, label: val.FirstName + " " + val.LastName } }));
                    formRef.current.setFieldValue("contactPerson", { value: json.oldContactPerson.ContactPersonID, label: json.oldContactPerson.FirstName + " " + json.oldContactPerson.LastName });
                    setOrganiastion(json.organisation);
                    formRef.current.setFieldValue("organisationName", json.organisation.OrganisationName);
                    formRef.current.setFieldValue("street", json.organisation.Street);
                    formRef.current.setFieldValue("houseNo", json.organisation.HouseNo);
                    formRef.current.setFieldValue("additionToAddress", json.organisation.AdditionToAddress);
                    formRef.current.setFieldValue("postCode", json.organisation.PostCode);
                    formRef.current.setFieldValue("city", json.organisation.City);
                    formRef.current.setFieldValue("expiration", json.organisation.ExpireTimeDefault);
                }
            }
            catch (e) {
                toast.error("Fehler beim Laden.");
            }
        };

        getOrganisationSettings();
    }, []);

    return <Formik
        validationSchema={schemaSchool}
        innerRef={(f) => formRef.current = f}
        onSubmit={(values) => {
            let organisationInfo = { OrganisationName: values.organisationName, Street: values.street, HouseNo: values.houseNo, AdditionToAddress: values.additionToAddress, PostCode: values.postCode, City: values.city, ExpireTimeDefault: values.expiration };
            let data = { equipment: values.equipment.map((val) => { return val.value; }), categories: values.categories.map((val) => { return val.value; }), contactPerson: values.contactPerson.value, expiration: values.expiration, organisationInfo: organisationInfo };
            updateSchool(data);
        }}
        initialValues={{
            organisationName: '',
            street: '',
            houseNo: '',
            additionToAddress: '',
            postCode: '',
            city: '',
            expiration: 0,
            equipment: [],
            categories: [],
            contactPerson: 0
        }}
    >
        {({
            handleSubmit,
            handleChange,
            handleBlur,
            values,
            touched,
            isValid,
            errors
        }) => {
            return <Form noValidate onSubmit={handleSubmit}>
                <Row>
                    <Col xs={12} md={6}>
                        <Form.Group className="form-group" controlId="organisationName">
                            <Form.Label>Schulname</Form.Label>
                            <Form.Control isInvalid={errors.organisationName && touched.organisationName} placeholder="" name="organisationName" value={values.organisationName} onBlur={handleBlur} onChange={handleChange} disabled />
                            <Form.Control.Feedback type="invalid">
                                {errors.organisationName}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Row className="form-group">
                            <Col xs={9}>
                                <Form.Group controlId="street">
                                    <Form.Label className="required">Straße</Form.Label>
                                    <Form.Control isInvalid={errors.street && touched.street} placeholder="" name="street" value={values.street} onBlur={handleBlur} onChange={handleChange} />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.street}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col xs={3}>
                                <Form.Group controlId="houseNo">
                                    <Form.Label className="required">Hausnummer</Form.Label>
                                    <Form.Control isInvalid={errors.houseNo && touched.houseNo} placeholder="" name="houseNo" value={values.houseNo} onBlur={handleBlur} onChange={handleChange} />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.houseNo}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                        </Row>

                        <Form.Group className="form-group" controlId="additionToAddress">
                            <Form.Label>Adresszusatz</Form.Label>
                            <Form.Control isInvalid={errors.additionToAddress && touched.additionToAddress} placeholder="" name="additionToAddress" value={values.additionToAddress} onBlur={handleBlur} onChange={handleChange} />
                            <Form.Control.Feedback type="invalid">
                                {errors.additionToAddress}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Row className="form-group">
                            <Col xs={6}>
                                <Form.Group controlId="postCode">
                                    <Form.Label className="required">Postleitzahl</Form.Label>
                                    <Form.Control isInvalid={errors.postCode && touched.postCode} placeholder="" name="postCode" value={values.postCode} onBlur={handleBlur} onChange={handleChange} />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.postCode}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col xs={6}>
                                <Form.Group controlId="city">
                                    <Form.Label className="required">Ort</Form.Label>
                                    <Form.Control isInvalid={errors.city && touched.city} placeholder="" name="city" value={values.city} onBlur={handleBlur} onChange={handleChange} />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.city}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={12} md={6}>
                        <Form.Group className="form-group" controlId="expiration">
                            <Form.Label>Standard-Ablaufzeit für Termine (in Stunden vor Termin-Begin)</Form.Label>
                            <Form.Control type="number" name="expiration" value={values.expiration} onBlur={handleBlur} onChange={handleChange} step="1"></Form.Control>
                        </Form.Group>

                        <Form.Group className="form-group" controlId="contactPerson">
                            <Form.Label>Standard-Ansprechpartner</Form.Label>
                            <Select name="contactPerson" options={contactPerson} classNamePrefix="bv-select" className="bv-select" value={values.contactPerson} onChange={
                                (values) => {
                                    formRef.current.setFieldValue("contactPerson", values);
                                }
                            } />
                        </Form.Group>

                        <Form.Group className="form-group" controlId="equipment">
                            <Form.Label>Standard-Ausstattung</Form.Label>
                            <Select isMulti closeMenuOnSelect={false} name="Equipment" options={equipment} classNamePrefix="bv-select" className="bv-select" value={values.equipment} placeholder="Bitte ausw&auml;hlen" onChange={
                                (values) => {
                                    let vals = values.map((v) => v);
                                    formRef.current.setFieldValue("equipment", vals);
                                }
                            } />
                        </Form.Group>

                        <Form.Group className="form-group" controlId="categories">
                            <Form.Label>NICHT erwünschte Betriebskategorien für neu zu erstellende Termine</Form.Label>
                            <Select isMulti closeMenuOnSelect={false} name="categories" options={categories} classNamePrefix="bv-select" className="bv-select" value={values.categories} placeholder="Bitte ausw&auml;hlen" onChange={
                                (values) => {
                                    let vals = values.map((v) => v);
                                    formRef.current.setFieldValue("categories", vals);
                                }
                            } />
                        </Form.Group>
                    </Col>
                </Row>

                <Row className="mt-3">
                    <Col>
                        <Button variant="secondary" type="submit">
                            <i className="fa-solid fa-right-to-bracket mr-2"></i>Daten speichern
                        </Button> 
                    </Col>
                </Row>
            </Form>
        } }
    </Formik>;
}

const OrganisationBusiness = (props) => {
    const [contactPerson, setContactPerson] = useState([]);
    const [organisation, setOrganiastion] = useState({});

    const formRef = useRef(null);

    const { request } = useRequest();

    const updateBusiness = async (values) => {
        let result = await request("/User/UpdateOrganisation", values);
        let json = result.data;
        if (json.r != 1) {
            if (json.message) {
                toast.error(json.message);
            }
            else {
                toast.error("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.");
            }
            return;
        }
        toast.success("Ihre Daten wurden erfolgreich geändert.");
    }

    useEffect(() => {
        const getOrganisationSettings = async () => {
            try {
                let result = await request("/User/GetOrganisationSettings");
                let json = result.data;
                if (json.r != 1) {
                    if (json.message) {
                        aler.error(json.message);
                    }
                    else {
                        toast.error("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut");
                    }
                }
                else {
                    setContactPerson(json.contactPerson.map((val) => { return { value: val.ContactPersonID, label: val.FirstName + " " + val.LastName } }));
                    formRef.current.setFieldValue("contactPerson", { value: json.oldContactPerson.ContactPersonID, label: json.oldContactPerson.FirstName + " " + json.oldContactPerson.LastName });
                    setOrganiastion(json.organisation);
                    formRef.current.setFieldValue("organisationName", json.organisation.OrganisationName);
                    formRef.current.setFieldValue("street", json.organisation.Street);
                    formRef.current.setFieldValue("houseNo", json.organisation.HouseNo);
                    formRef.current.setFieldValue("additionToAddress", json.organisation.AdditionToAddress);
                    formRef.current.setFieldValue("postCode", json.organisation.PostCode);
                    formRef.current.setFieldValue("city", json.organisation.City);
                    formRef.current.setFieldValue("court", json.organisation.Court);
                    formRef.current.setFieldValue("compRegNo", json.organisation.CompRegNo);
                    formRef.current.setFieldValue("chamberMembership", json.organisation.ChamberMembership);
                    formRef.current.setFieldValue("isInstitution", json.organisation.IsInstitution);
                    formRef.current.setFieldValue("filenameBusinessLicense", json.organisation.FilenameBusinessLicense);
                    if (json.organisation.BillingStreet != null && json.organisation.BillingStreet.length > 0) {
                        formRef.current.setFieldValue("isAlternativeBilling", true);
                        formRef.current.setFieldValue("BillingEmail", json.organisation.BillingEmail);
                        formRef.current.setFieldValue("BillingStreet", json.organisation.BillingStreet);
                        formRef.current.setFieldValue("BillingHouseNo", json.organisation.BillingHouseNo);
                        formRef.current.setFieldValue("BillingAdditionToAddress", json.organisation.BillingAdditionToAddress);
                        formRef.current.setFieldValue("BillingPostCode", json.organisation.BillingPostCode);
                        formRef.current.setFieldValue("BillingCity", json.organisation.BillingCity);
                    }      
                }
            }
            catch (e) {
                toast.error("Fehler beim Laden.");
            }
        };

        getOrganisationSettings();
    }, []);

    return <Formik
        innerRef={(f) => formRef.current = f}
        validationSchema={schemaBusiness}
        onSubmit={(values) => {
            let organisationInfo = { OrganisationName: values.organisationName, Street: values.street, HouseNo: values.houseNo, AdditionToAddress: values.additionToAddress, PostCode: values.postCode, City: values.city };
            if (values.isAlternativeBilling) {
                organisationInfo = { ...organisationInfo, BillingEmail: values.BillingEmail, BillingStreet: values.BillingStreet, BillingHouseNo: values.BillingHouseNo, BillingAdditionToAddress: values.BillingAdditionToAddress, BillingPostCode: values.BillingPostCode, BillingCity: values.BillingCity }
            }
           
            let data = { contactPerson: values.contactPerson.value, organisationInfo: organisationInfo };

            updateBusiness(data);
        }}
        initialValues={{
            organisationName: '',
            street: '',
            houseNo: '',
            additionToAddress: '',
            postCode: '',
            city: '',
            court: '',
            compRegNo: '',
            chamberMembership: '',
            filenameBusinessLicense: '',
            isInstitution: false,
            contactPerson: 0,
            BillingStreet: '',
            BillingHouseNo: '',
            BillingAdditionToAddress: '',
            BillingCity: '',
            BillingPostCode: '',
            BillingEmail: '',
            isAlternativeBilling: false,
        }}
    >
        {({
            handleSubmit,
            handleChange,
            handleBlur,
            values,
            touched,
            isValid,
            errors
        }) => {
            return <Form noValidate onSubmit={handleSubmit}>
                <Row>
                    <Col xs={12} sm={6}>
                        <Form.Group className="form-group" controlId="organisationName">
                            <Form.Label>Name</Form.Label>
                            <Form.Control isInvalid={errors.organisationName && touched.organisationName} placeholder="" name="organisationName" value={values.organisationName} onBlur={handleBlur} onChange={handleChange} disabled />
                            <Form.Control.Feedback type="invalid">
                                {errors.organisationName}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Row className="form-group">
                            <Col xs={9}>
                                <Form.Group controlId="street">
                                    <Form.Label className="required">Straße</Form.Label>
                                    <Form.Control isInvalid={errors.street && touched.street} placeholder="" name="street" value={values.street} onBlur={handleBlur} onChange={handleChange} />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.street}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col xs={3}>
                                <Form.Group controlId="houseNo">
                                    <Form.Label className="required">Hausnummer</Form.Label>
                                    <Form.Control isInvalid={errors.houseNo && touched.houseNo} placeholder="" name="houseNo" value={values.houseNo} onBlur={handleBlur} onChange={handleChange} />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.houseNo}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                        </Row>




                        <Form.Group className="form-group" controlId="additionToAddress">
                            <Form.Label>Addresszusatz</Form.Label>
                            <Form.Control isInvalid={errors.additionToAddress && touched.additionToAddress} placeholder="" name="additionToAddress" value={values.additionToAddress} onBlur={handleBlur} onChange={handleChange} />
                            <Form.Control.Feedback type="invalid">
                                {errors.additionToAddress}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Row className="form-group">
                            <Col xs={6}>
                                <Form.Group controlId="postCode">
                                    <Form.Label className="required">Postleitzahl</Form.Label>
                                    <Form.Control isInvalid={errors.postCode && touched.postCode} placeholder="" name="postCode" value={values.postCode} onBlur={handleBlur} onChange={handleChange} />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.postCode}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col xs={6}>
                                <Form.Group controlId="city">
                                    <Form.Label className="required">Ort</Form.Label>
                                    <Form.Control isInvalid={errors.city && touched.city} placeholder="" name="city" value={values.city} onBlur={handleBlur} onChange={handleChange} />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.city}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                        </Row>

                        <Form.Group className="form-group" controlId="isAlternativeBilling">
                            <Form.Check type="checkbox" label="Abweichende Rechnungsadresse" checked={values.isAlternativeBilling} onChange={handleChange} />
                        </Form.Group>

                        {values.isAlternativeBilling && (
                            <>
                                <Separator style={{ margin: 0 }} text="Rechnungsadresse" />

                                <Form.Group className="form-group" controlId="BillingEmail">
                                    <Form.Label className="required">E-Mail-Adresse</Form.Label>
                                    <Form.Control isInvalid={errors.BillingEmail && touched.BillingEmail} placeholder="" name="BillingEmail" value={values.BillingEmail} onBlur={handleBlur} onChange={handleChange} />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.BillingEmail}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Row className="form-group">
                                    <Col xs={9}>
                                        <Form.Group controlId="BillingStreet">
                                            <Form.Label className="required">Straße</Form.Label>
                                            <Form.Control isInvalid={errors.BillingStreet && touched.BillingStreet} placeholder="" name="BillingStreet" value={values.BillingStreet} onBlur={handleBlur} onChange={handleChange} />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.BillingStreet}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                    <Col xs={3}>
                                        <Form.Group controlId="BillingHouseNo">
                                            <Form.Label className="required">Hausnummer</Form.Label>
                                            <Form.Control isInvalid={errors.BillingHouseNo && touched.BillingHouseNo} placeholder="" name="BillingHouseNo" value={values.BillingHouseNo} onBlur={handleBlur} onChange={handleChange} />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.BillingHouseNo}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Form.Group className="form-group" controlId="BillingAdditionToAddress">
                                    <Form.Label>Adresszusatz</Form.Label>
                                    <Form.Control isInvalid={errors.BillingAdditionToAddress && touched.BillingAdditionToAddress} placeholder="" name="BillingAdditionToAddress" value={values.BillingAdditionToAddress} onBlur={handleBlur} onChange={handleChange} />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.BillingAdditionToAddress}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Row className="form-group">
                                    <Col xs={6}>
                                        <Form.Group controlId="BillingPostCode">
                                            <Form.Label className="required">Postleitzahl</Form.Label>
                                            <Form.Control isInvalid={errors.BillingPostCode && touched.BillingPostCode} placeholder="" name="BillingPostCode" value={values.BillingPostCode} onBlur={handleBlur} onChange={handleChange} />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.BillingPostCode}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                    <Col xs={6}>
                                        <Form.Group controlId="BillingCity">
                                            <Form.Label className="required">Stadt</Form.Label>
                                            <Form.Control isInvalid={errors.BillingCity && touched.BillingCity} placeholder="" name="BillingCity" value={values.BillingCity} onBlur={handleBlur} onChange={handleChange} />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.BillingCity}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </>
                        )}
                    </Col>
                    <Col xs={12} sm={6}>
                        {values.court != null && values.court.length > 0 && (
                            <Form.Group className="form-group" controlId="court">
                                <Form.Label>Amtsgericht</Form.Label>
                                <Form.Control isInvalid={errors.court && touched.court} placeholder="" name="court" value={values.court} onBlur={handleBlur} onChange={handleChange} disabled />
                                <Form.Control.Feedback type="invalid">
                                    {errors.court}
                                </Form.Control.Feedback>
                            </Form.Group>
                        )}

                        {values.compRegNo != null && values.compRegNo.length > 0 && (
                            <Form.Group className="form-group" controlId="compRegNo">
                                <Form.Label>Handelsregisternummer</Form.Label>
                                <Form.Control isInvalid={errors.compRegNo && touched.compRegNo} placeholder="" name="compRegNo" value={values.compRegNo} onBlur={handleBlur} onChange={handleChange} disabled />
                                <Form.Control.Feedback type="invalid">
                                    {errors.compRegNo}
                                </Form.Control.Feedback>
                            </Form.Group>
                        )}

                        {values.chamberMembership != null && values.chamberMembership.length > 0 && (
                            <Form.Group className="form-group" controlId="chamberMembership">
                                <Form.Label>Kammerzugehörigkeit</Form.Label>
                                <Form.Control isInvalid={errors.chamberMembership && touched.chamberMembership} placeholder="" name="chamberMembership" value={values.chamberMembership} onBlur={handleBlur} onChange={handleChange} disabled />
                                <Form.Control.Feedback type="invalid">
                                    {errors.chamberMembership}
                                </Form.Control.Feedback>
                            </Form.Group>
                        )}

                        {values.filenameBusinessLicense != null && values.filenameBusinessLicense.length > 0 && (
                            <Form.Group className="form-group" controlId="filenameBusinessLicense">
                                <Form.Label>Gewerbeschein-Upload</Form.Label>
                                <Form.Control isInvalid={errors.filenameBusinessLicense && touched.filenameBusinessLicense} placeholder="" name="filenameBusinessLicense" value={values.filenameBusinessLicense} onBlur={handleBlur} onChange={handleChange} disabled />
                                <Form.Control.Feedback type="invalid">
                                    {errors.filenameBusinessLicense}
                                </Form.Control.Feedback>
                            </Form.Group>
                        )}

                        {values.isInstitution && (
                            <Form.Group className="form-group" controlId="isInstitution">
                                <Form.Label>Institution des öffentlichen Rechts</Form.Label>
                                <Form.Check type="checkbox" label="ist Anstalt oder Körperschaft des öffentlichen Rechts" checked={values.isInstitution} onChange={handleChange} disabled />
                            </Form.Group>
                        )}

                        <Form.Group className="form-group" as={Row} controlId="contactPerson">
                            <Form.Label>Ansprechpartner</Form.Label>
                            <Col sm="12">
                                <Select name="contactPerson" options={contactPerson} classNamePrefix="bv-select" className="bv-select" value={values.contactPerson} onChange={
                                    (values) => {
                                        formRef.current.setFieldValue("contactPerson", values);
                                    }
                                } />
                            </Col>
                        </Form.Group>
                    </Col>
                </Row>
                <Row className="mt-3">
                    <Col>
                        <Button variant="secondary" type="submit">
                            <i className="fa-solid fa-check mr-2"></i>Daten speichern
                        </Button> 
                    </Col>
                </Row>

                <MandatoryFieldNotice />
            </Form>
        }}
    </Formik>;
}

export default Organisation;